angular.module("dx.webapp.question", [
	"digiexam.exam",

	"dx.ui.components.localize",
	"dx.ui.dataTypes.grading",
	"dx.ui.dataTypes.question",
]);
